import { Box, Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { ChevronDown, X } from 'lucide-react';
import { useCallback } from 'react';
import { States } from '@duke-hq/svc-api-db/schemas/enums/States.schema';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export function StatesFilter({
  stateFilter,
  stateOptions,
  setStateFilter,
}: {
  stateFilter?: States;
  stateOptions?: { label: string; value: States }[];
  setStateFilter: (value: States | undefined) => void;
}) {
  const handleClearFilter = useCallback(() => {
    setStateFilter(undefined);
  }, [setStateFilter]);

  let stateLabel = 'State';

  if (stateOptions && stateFilter) {
    const stateOption = stateOptions.find((state) => state.value === stateFilter);
    if (stateOption) {
      stateLabel = stateOption.label;
    }
  }

  return (
    <Box>
      <Menu>
        <MenuButton
          as={Button}
          variant="outline"
          px={2}
          size="sm"
          width="auto"
          colorScheme="gray"
          rightIcon={
            stateFilter ? (
              <Box p={0} minW="fit-content" onClick={handleClearFilter} ml={1}>
                <X size={iconSize.md} />
              </Box>
            ) : (
              <ChevronDown size={iconSize.md} />
            )
          }
        >
          {stateLabel}
        </MenuButton>
        <MenuList>
          {(stateOptions || []).map((state) => (
            <StateOption key={state.value} state={state} setStateFilter={setStateFilter} />
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
}

function StateOption({
  state,
  setStateFilter,
}: {
  state: { label: string; value: States };
  setStateFilter: (value: States | undefined) => void;
}) {
  return (
    <MenuItem
      key={state.value}
      onClick={() => {
        setStateFilter(state.value);
      }}
    >
      {state.label}
    </MenuItem>
  );
}
